import { render } from "./RoleDescription.vue?vue&type=template&id=cd17eb0e&scoped=true&ts=true"
import script from "./RoleDescription.vue?vue&type=script&lang=ts"
export * from "./RoleDescription.vue?vue&type=script&lang=ts"

import "./RoleDescription.vue?vue&type=style&index=0&id=cd17eb0e&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd17eb0e"]])

export default __exports__